import { render, staticRenderFns } from "./lookList.vue?vue&type=template&id=1ccc7840&scoped=true"
import script from "./lookList.vue?vue&type=script&lang=js"
export * from "./lookList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccc7840",
  null
  
)

export default component.exports